export default __webpack_public_path__ + "static/media/sprite-object.dd6146db.svg";